import './presentation/styles/main.scss';
import toggleSiteItems from './presentation/scripts/header.js';

//Klick accessible components

import './presentation/scripts/vendors/componentUtils.js';
import './presentation/scripts/vendors/componentShim.js';

const accordion = require('@klickinc/klick-component-accordion-accessible');
window.accordion = accordion; // Make object available for screenshots.
import './presentation/scripts/vendors/accordion.shim.js';

const tab = require('@klickinc/klick-component-tabs-accessible');
window.tab = tab; // Make object available for screenshots.
import './presentation/scripts/vendors/tabs.shim.js';

const modal = require('@klickinc/klick-component-modal-accessible');
window.modal = modal; // Make object available for screenshots.
import './presentation/scripts/vendors/modal.shim.js';
import modalCustom from './presentation/scripts/modal.js';
import exitModalInit from './presentation/scripts/modal.complement.exit.js';
import hcpConfirmation from './presentation/scripts/hcp-confirmation';

import filterTreatments from './presentation/scripts/filter-treatments';

//scripts for global components

import formInit from './presentation/scripts/forms.js';
import screenshots from './presentation/scripts/screenshots';
import dynamicAssetsAccordions from './presentation/scripts/dynamic-assets-accordions.js';

import './presentation/scripts/patterns/dynamic-html';
import './presentation/scripts/patterns/load-more.utils';
import './presentation/scripts/patterns/toggle-congress-filters';
import './presentation/scripts/populate-dropdowns';
import './presentation/scripts/populate-congress';
import './presentation/scripts/populate-publication';
import './presentation/scripts/query-liaison';
import './presentation/scripts/checkbox-dropdown.js';

document.addEventListener('DOMContentLoaded', () => {
    dynamicAssetsAccordions();
    toggleSiteItems();
    modalCustom();
    exitModalInit();
    hcpConfirmation();
    screenshots();
    if ( document.querySelector('form') ){
        formInit();
    }
    if ( document.querySelector('.guidelines') || document.querySelector('.protocols') ) {
        filterTreatments();
    }

    //Prevent focus on click on most tabindex="-1" elements
    if(document.querySelector('div[tabindex="-1"]')) {
        document.querySelectorAll('div[tabindex="-1"]').forEach((d) => {
            if(d !== document.querySelector('#tabpanel-0 > div') && d !== document.querySelector('#tabpanel-1 > div')) {
                d.addEventListener('mousedown', (e) => {
                    e.preventDefault();
                });
            }
        });
    }
});
